<template>
  <div class="practice-unit">
    <div class="layout-content">
      <SubTitle class="title" :text="data.title" />

      <div class="unit">
        <div class="unit-content">
          <div class="unit-content-list" v-for="item in data.list" :key="item.id">
            <img class="unit-content-img" :src="item.img" alt="">
          </div>
        </div>
        <div class="unit-warning">{{data.warning}}</div>
      </div>

    </div>
  </div>
</template>

<script>

import SubTitle from '@/components/SubTitle'

export default {
  props: ['data'],
  data () {
    return {

    }
  },
  components: {
    SubTitle
  }
}
</script>

<style lang="scss" scoped>

.practice-unit {
  background: #F7F8FA;
}

.unit {
  display: flex; flex-direction: column; justify-content: center; align-items: center;
  padding: 20px 0 120px;

  @include mobile {
    padding: 20px 0 60px;
  }
}

.unit-content {
  display: flex;
  flex-wrap: wrap; justify-content: center;

  @include mobile {
    justify-content: space-between;
    padding: 0 0 0 0;
  }
}

.unit-content-list {
  margin: 0 32px 40px 0;

  &:nth-child(5n) {
    margin-right: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  @include mobile {
    margin: 0 0 15px 0;
    width: calc(calc(100% - 15px) / 2);
  }
}

.unit-content-img {
  width: 214px; height: 80px;

  @include mobile {
    width: 100%; height: auto;
  }
}

.unit-warning {
  margin-top: 20px;
  color: #000000;
  font-size: 16px; font-weight: 400;
  line-height: 35px;
  opacity: 0.5;

  @include mobile {
    margin: 0 0 50px;
    font-size: 13px; line-height: 1.6;
  }
}

</style>
